export default {
  GET_MATERIALS: state => state.materials,
  GET_MATERIALS_TABLE_ID: state => state.materialsVid,
  GET_MATERIAL_REMAINS: state => state.materialRemains,
  GET_MATERIALS_FOR_ENTERING: state => state.materialsForEntering,
  GET_PRODUCT_CATEGORIES: state => state.product_categories,
  GET_MODAL_DETAILS:state =>state.details_modal,
  GET_MATERIALS_FOR_BUILDERS:state =>state.material_for_builds
}
